import React, {useMemo} from "react";
import PropTypes from "prop-types";
import './styles/PrimaryButton.css';

export function CustomButton({disabled, text, type, className, onClick, styleType = "primary", title}) {

    const buttonsClasses = useMemo(() => {
        const classes = [];

        switch (styleType) {
            case 'primary':
                classes.push('button-with-animation');
                break;
            case 'secondary':
                classes.push('secondary-button');
                break;
            case 'tertiary':
                classes.push('secondary-button tertiary-button');
        }

        if (className) {
            classes.push(className);
        }

        if (disabled) {
            classes.push("disabled")
        }

        return classes.join(' ');
    }, [className, styleType, disabled])

    function onClickHandler() {
        if (!onClick) {
            return;
        }
        onClick();
    }

    return (
        <button
            className={buttonsClasses}
            type={type}
            disabled={disabled}
            title={title}
            onClick={onClickHandler}
        >
            {
                styleType === 'primary' && <>
                    <span className={'button-animation first'}></span>
                    <span className={'button-animation second'}></span>
                </>
            }
            {text}
        </button>
    )
}

CustomButton.propTypes = {
    text: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    styleType: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    title: PropTypes.string,
}

